import React, { useState } from "react";
import {
  TitleContainer,
  TitleTextHolder,
  TitleText,
  ButtonContainer,
  SubtitleText,
  PaymentLinkContainer,
  PaymentLinkHeader,
  TitleSearchContainer,
  PaymentLinkTitleText,
  EmptyDashboardContainer,
  FilterContainer,
  Container,
  CalendarTextHolder,
  CalendarText,
  CalendarLinkText,
  ExportDataButton,
  ExportIcon,
  ExportButtonandSettingIconPhone,
} from "./PaymentLink.styles";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import SearchBar from "../../components/SearchBar/SearchBar";

import { LuCalendarDays } from "react-icons/lu";
import { RxDividerVertical } from "react-icons/rx";
import Table from "./Component/Table";
import EmptyDashBoard from "../../components/DashBoardComponents/EmptyDashBoard";
import { useNavigate } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import HomeBigChat from "../../components/DashBoardComponents/Home/HomeBigChart/index";
import { data } from "../../components/DashBoardComponents/Home/HomeBigChart/bigchartdata";
import {
  paymentLinkTableHeader,
  transactionTableHeader,
} from "./Component/TableData";
import { EmptyAnalytics } from "../AnalyticsTable/EmptyAnalytics";
// import { UserTableBodyData } from "./data";
import { FilterComponent } from "../../components/FilterComponent";
import { ExportButton } from "../../components/Button/ExportButton";
import { TabNavigation } from "./TabNavigation";

import { export_icon } from "../../../public/assets";
import { useQuery } from "@apollo/client";
import {
  GET_ALL_TRANSACTIONS,
  GET_TRANSACTION_BY_ORGANIZATION_ID,
} from "../../graphql/queries/transaction";
import environment from "../../env";
import { newTableHeaderData } from "../../components/DashBoardComponents/Transaction/TransactionTableData";
import { GET_PAYMENT_LINK_BY_ORGANIZATION_ID } from "../../graphql/queries/paymentlink";
import { mapPaymentLinkTableData } from "./Component/PaymentLinkTable";
import ErrorPage from "../../components/ErrorComponent/ErrorPage";

const PaymentLinkTable = () => {
  const [activeLink, setActiveLink] = useState<number>(1);
  const [activeButton, setActiveButton] = useState<number>(1);
  const navigate = useNavigate();

  const {
    loading: transactionLoading,
    error: transactionError,
    data: transactionDataQuery,
  } = useQuery(GET_TRANSACTION_BY_ORGANIZATION_ID, {
    variables: {
      ...environment.paymentLinkService,
      payload: {
        limit: 10,
        page: 1,
      },
    },
  });

  const transactionData =
    transactionDataQuery?.getAllTransactionsByOrganizationId?.data || [];

  const {
    loading: paymentLinkLoading,
    error: paymentLinkError,
    data: paymentLinkDataQuery,
  } = useQuery(GET_PAYMENT_LINK_BY_ORGANIZATION_ID, {
    variables: {
      ...environment.paymentLinkService,
      payload: {
        limit: 10,
        page: 1,
      },
    },
  });

  const paymentLinkData =
    paymentLinkDataQuery?.getAllpaymentLinkByOrganizationId?.data || [];

  if (transactionLoading || paymentLinkLoading) return <p>Loading...</p>;
  if (transactionError || paymentLinkError)
    return (
      <ErrorPage />
      // <p>Error: {transactionError?.message || paymentLinkError?.message}</p>
    );

  const gotoSettings = () => {
    navigate("/dashboard/settings");
  };

  return (
    <>
      <TitleContainer>
        <TitleTextHolder>
          <TitleText>Payment Link</TitleText>
          <SubtitleText>Add new products and create payment link</SubtitleText>
        </TitleTextHolder>
        <ButtonContainer>
          <Buttons
            label="Create Payment Link"
            backgroundColor={colors.ButtonBackgroundColors.primaryDefaultButton}
            borderRadius="10px"
            color={colors.ButtonBackgroundColors.primaryDefaultButton}
            cursor="pointer"
            height="44px"
            width="184px"
            textColor={colors.White}
            handleClick={() => navigate("/dashboard/add-product")}
            style={{
              width: "100%",
              height: "44px",
              borderRadius: "10px",
              color: "white",
              backgroundColor: "#00A603",
            }}
          />
        </ButtonContainer>
      </TitleContainer>
      <PaymentLinkContainer>
        <PaymentLinkHeader>
          <TitleSearchContainer>
            <PaymentLinkTitleText>My Payment Links</PaymentLinkTitleText>{" "}
            <SearchBar
              onSearch={function (searchItem: string): void {
                throw new Error("Function not implemented.");
              }}
            />
          </TitleSearchContainer>

          <FilterContainer>
            <LuCalendarDays
              color={colors.ButtonBackgroundColors.primaryDefaultButton}
              size={"20px"}
            />
            <CalendarTextHolder>
              <CalendarText>From: </CalendarText>
              <CalendarLinkText>Start Date</CalendarLinkText>
            </CalendarTextHolder>
            <RxDividerVertical color={colors.LIGHT_GRAY} />
            <CalendarTextHolder>
              <CalendarText>To: </CalendarText>
              <CalendarLinkText> End Date</CalendarLinkText>
            </CalendarTextHolder>
          </FilterContainer>
        </PaymentLinkHeader>
        <TabNavigation
          onSettingsClick={gotoSettings}
          onTabChange={setActiveButton}
          activeTab={activeButton}
          onDropdownChange={setActiveLink}
          activeLink={activeLink}
        />
        {activeButton === 2 && (
          <>
            {transactionData.length === 0 ? (
              <EmptyDashboardContainer>
                <EmptyDashBoard
                  titleText="No transaction history"
                  subtitleText="All transaction history will be displayed here"
                />
              </EmptyDashboardContainer>
            ) : (
              <Table
                headData={transactionTableHeader}
                bodyData={transactionData}
                status="transaction"
              />
            )}
          </>
        )}
        {activeButton === 1 && (
          <>
            {paymentLinkData.length === 0 ? (
              <EmptyDashboardContainer>
                <EmptyDashBoard
                  titleText="No payment link history"
                  subtitleText="All payment link history will be displayed here"
                />
              </EmptyDashboardContainer>
            ) : (
              <Table
                map={mapPaymentLinkTableData}
                headData={paymentLinkTableHeader}
                bodyData={paymentLinkData}
                status="payment"
              />
            )}
          </>
        )}{" "}
      </PaymentLinkContainer>

      {data.length === 2292929292921 ? (
        <EmptyAnalytics title={"Payment Analytics"} />
      ) : (
        <>
          <br />
          <br />
          <Container>
            <HomeBigChat />
          </Container>
        </>
      )}
    </>
  );
};

export default PaymentLinkTable;
